import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import { useRoutes } from 'react-router-dom';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import routes from 'src/routes';
// import Authenticate from './views/auth/Authenticate';

const AuthenticatedRoutes = () => {
  return useRoutes([routes[0]]);
};

const UnauthenticatedRoutes = () => {
  return useRoutes([routes[1]]);
};

const AuthenticateComp = () => {
  const token = useSelector(state => state.Auth.token);
  const routing = token ? <AuthenticatedRoutes /> : <UnauthenticatedRoutes />;

  return routing;
};

const App = () => {
  const token = sessionStorage.getItem('token');
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthenticateComp />
    </ThemeProvider>
  );
};

export default App;
